import { TicketsStatusReference } from '@/types/codegen-federation'

/**
 * Checks if tickets are currently being sold for a theatrical release.
 * Returns true if the ticketStatus is 'PRE_SALES' or 'LIVE'.
 * @param ticketStatus - The ticket status from the theatrical release
 */
export const isSellingTickets = (ticketStatus?: TicketsStatusReference | null): boolean => {
  return ticketStatus === 'PRE_SALES' || ticketStatus === 'LIVE'
}

/**
 * Checks if tickets are currently being sold for a theatrical release in the future.
 * Returns true if the ticketStatus is 'PRE_SALES' or 'COMING_SOON'.
 * @param ticketStatus - The ticket status from the theatrical release
 */
export const willBeInTheaters = (ticketStatus?: TicketsStatusReference | null): boolean => {
  return ticketStatus === 'PRE_SALES' || ticketStatus === 'COMING_SOON'
}

/**
 * Checks if a project is currently in theaters.
 * Returns true if the ticketStatus is 'LIVE'.
 * @param ticketStatus - The ticket status from the theatrical release
 */
export const inTheaters = (ticketStatus?: TicketsStatusReference | null): boolean => {
  return ticketStatus === 'LIVE'
}
